import { PrivateAPINamespace } from '../PrivateAPINamespace';

export class UserPreferencesNamespace extends PrivateAPINamespace {
  static readonly namespace = 'userPreferences';

  set(appDefinitionId: string, preferences: Record<string, any>) {
    return this.ps.hostAPI.editor.userPreferences.set(
      appDefinitionId,
      preferences,
    );
  }

  get(appDefinitionId: string, keys: string[]) {
    return this.ps.hostAPI.editor.userPreferences.get(appDefinitionId, keys);
  }
}
